import { Component, OnInit, Input } from "@angular/core";
import { Store } from "@ngrx/store";
import { AppState, stateGetter } from "src/app/store/state/app.state";
import { CompanyDataService } from "../company-data.service";
import { CompanyPageMeta } from "src/app/store/models/company-page-store.model";
import { NzMessageService } from "ng-zorro-antd/message";

@Component({
  selector: "app-normalize-forecast",
  templateUrl: "./normalize-forecast.component.html",
  styleUrls: ["./normalize-forecast.component.scss"],
})
export class NormalizeForecastComponent implements OnInit {
  @Input() ticker: string;
  companyName: string;
  userType: string;
  tickerPrioritized: boolean;
  normalizeForecastBtnText = "";
  usersnapJsKey: any;
  snapEmail: any;
  userName: any;
  apiUrl = window.apiUrl;

  constructor(
    private store: Store<AppState>,
    private dataService: CompanyDataService,
    private message: NzMessageService,
  ) {}

  ngOnInit() {
    this.store
      .select(stateGetter("globalHeader", "globalSettings"))
      .subscribe((data: any) => {
        this.usersnapJsKey = data.usersnapJsKey;
        this.snapEmail = data.userDetails ? data.userDetails.email : "";
        this.userName = data.userName;
      });
    this.store.select(stateGetter("companyPage", "meta")).subscribe((data) => {
      if (data[this.ticker]) {
        const metaData: CompanyPageMeta = data[this.ticker];
        this.companyName = metaData.company_name;
        this.userType = metaData.user_type;
        this.tickerPrioritized = metaData.ticker_prioritized;
        this.normalizeForecastBtnText = this.tickerPrioritized
          ? "Requested"
          : "Prioritize";
      } else {
        console.error("Ticker data not found");
      }
    });
  }

  setPrioritize() {
    if (this.usersnapJsKey && this.usersnapJsKey !== "") {
      window.Usersnap.init({
        button: { isHidden: true },
      });
      window.Usersnap.on("open", (event) => {
        event.api.setValue("custom", {
          email: `##${this.snapEmail}##`,
          username: this.userName,
          ticker: this.ticker,
        });
        event.api.setValue("email", this.snapEmail);
        event.api.setValue(
          "comment",
          "Please initiate coverage on this company.",
        );
      });
      window.Usersnap.on("submit", () => {
        this.dataService.trackUserRequest(this.ticker).subscribe(
          (respObject) => {
            if (respObject.status === "success") {
              //success toastr
              this.message.success(
                `We have received your request and will prioritize accordingly. You will receive an email notification once the normalization is completed.`,
                {
                  nzDuration: 2000,
                },
              );
              this.dataService.getCompanyMeta(this.ticker).subscribe();

              this.normalizeForecastBtnText = "Requested";
            } else {
              // error toastr
              this.message.error(
                `Error: Failed to recieve request. Please try again later.`,
                {
                  nzDuration: 2000,
                },
              );
            }
          },
          () => {
            //error toastr
            this.message.error(
              `Error: Failed to recieve request. Please try again later.`,
              {
                nzDuration: 2000,
              },
            );
          },
        );
      });
      setTimeout(() => {
        window.Usersnap.open();
      }, 1000);
    }
  }
}
